import { func, bool, object, string } from 'prop-types'
import { CheckBox, InputV2, Select } from '../Inputs'
import { Tooltip } from '../PopoverV2'
import { kuiperClassNames, renderIcon } from '../utils'
import { styles } from './styles'

const directionOptions = [
  { id: 1, title: 'Forward' },
  { id: 2, title: 'Backward' },
]

const StoryMomentContentRescheduler = ({
  onChangeDays,
  onChangeDirection,
  onChangeEnabled,
  rescheduleEnabled,
  shiftDays,
  shiftDirection,
}) => (
  <div css={styles.layout}>
    <div css={styles.header}>
      <CheckBox
        theme="dark"
        label="Reschedule Story's Moments and Content"
        value={rescheduleEnabled}
        onChange={onChangeEnabled}
      />
      <Tooltip
        className={kuiperClassNames('background-hoverable-info')}
        trigger={renderIcon('info', {
          style: { height: 14, width: 14 },
          ariaMode: 'presentational',
        })}
        content="This moves all Moments and Content in this Story forward or backward at once."
        position="top"
      />
    </div>
    <div css={styles.body}>
      <span>Move Moments and Content</span>
      <div css={styles.shiftDirection}>
        <Select
          placeholder="forward"
          value={shiftDirection}
          options={directionOptions}
          onSelect={onChangeDirection}
          theme="dark"
        />
      </div>
      <div css={styles.shiftDays}>
        <InputV2
          className={kuiperClassNames('shift-days-input')}
          maxLength={3}
          minValue={0}
          onChange={onChangeDays}
          theme="dark"
          type="number"
          strict={true}
          value={shiftDays}
        />
      </div>
      <span>Days</span>
    </div>
  </div>
)

StoryMomentContentRescheduler.propTypes = {
  onChangeDays: func,
  onChangeDirection: func,
  onChangeEnabled: func,
  rescheduleEnabled: bool,
  shiftDays: string,
  shiftDirection: object,
}

export default StoryMomentContentRescheduler
